__turbopack_context__.v({
  "myPurchase": "PromoPill-module-scss-module__JQqHEq__myPurchase",
  "promo": "PromoPill-module-scss-module__JQqHEq__promo",
  "promoContainer": "PromoPill-module-scss-module__JQqHEq__promoContainer",
});
